import {
  type TagSettings,
  type UpdateTagSettingsInput,
  tagSettingsSchema,
  updateTagSettingsInputSchema,
} from '../domains/tag-settings/schema';
import { apiRequest } from './api-client';

export async function getTagSettings(siteId: string): Promise<TagSettings> {
  const data = await apiRequest<unknown>(`/api/sites/${encodeURIComponent(siteId)}/tag-settings`);
  return tagSettingsSchema.parse(data);
}

export async function updateTagSettings(siteId: string, input: UpdateTagSettingsInput): Promise<TagSettings> {
  const validated = updateTagSettingsInputSchema.parse(input);

  const data = await apiRequest<unknown>(`/api/sites/${encodeURIComponent(siteId)}/tag-settings`, {
    method: 'PUT',
    body: validated,
  });
  return tagSettingsSchema.parse(data);
}
